import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
//import LanguageDetector from 'i18next-browser-languagedetector';
import enJson from './locales/en.json';
import deJson from './locales/de.json';

// Get language from URL query parameter `?lang=...`
const urlParams = new URLSearchParams(window.location.search);
const langFromUrl = urlParams.get('lang');

i18n
    //.use(LanguageDetector)
    .use(initReactI18next)
    .init({
        resources: {
            en: {
                translation: enJson
            },
            de: {
                translation: deJson
            },
        },
        lng: langFromUrl || 'de', // default language
        fallbackLng: 'en', // fallback language
        interpolation: {
            escapeValue: false // React will escape html entities (XSS attacks), so this should be false
        }
    });

export default i18n;